<template>
    <div class="animated fadeIn">
        <b-card>
            <form @submit.prevent="validate">
                <div class="form-row justify-content-start"  v-if="$auth.isPartner || $auth.isFinance || $auth.isBackoffice">
                                     
                    <div class="col-md-4" v-if="viewType != 'Partner'">
                        <div class="form-group">
                            <label>{{viewType == 'Seller' ? 'Empresas' : 'Representantes'}}</label>
                            <model-list-select
                                :list="customers.data"
                                option-value="id"
                                option-text="name"
                                v-model="request.customer"
                                :placeholder="viewType == 'Seller' ? 'Digite o nome da empresa' : 'Digite o nome do representante'"
                                @searchchange="searchCustomers"
                            ></model-list-select>
                        </div>
                    </div>               
                </div>
                <input type="submit" class="btn btn-primary" value="Consultar" />
            </form>
        </b-card>
        <template v-if="selectedCustomer.id != ''">
            <h4 class="mt-5 mb-3">{{selectedCustomer.name}}</h4>
            <balance-summary ref="bSummary" v-model="summaryModel" />
            <b-card>
                <form @submit.prevent="validateAdvanceSimulation">
                    <div class="form-row justify-content-start">                                         
                        <div class="col-md-2">
                            <div class="form-group">
                                <label>Valor</label>
                                <vue-numeric
                                    :separator="vueNumericDefaults.separator"
                                    :precision="vueNumericDefaults.decimals"
                                    :output-type="vueNumericDefaults.outputType"
                                    v-model="request.amount"
                                    :class="{'form-control': true}"
                                />                            
                            </div>
                        </div>                 
                    </div>
                    <input type="submit" class="btn btn-primary" value="Simular" />          
                </form>
            </b-card>
            <template v-if="advanceResult.id != ''">
                <h4 class="mt-5 mb-3">Transações disponíveis</h4>
                <div class="row justify-content-start mb-3">
                    <div class="col-md-2 col-sm-12">
                        <form @submit.prevent="antecipate">
                            <input type="submit" class="btn btn-primary" value="Antecipar" />
                        </form>
                    </div>
                </div>
                <b-card>
                    <div class="row">
                        <div class="col-md-2 col-sm-12">
                            <div class="callout">
                                <small class="text-muted">Total</small>
                                <h4 class="h4">{{ advanceSummary.totalTransactions.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</h4>
                            </div>
                        </div>
                        <div class="col-md-2 col-sm-12">
                            <div class="callout callout-warning">
                                <small class="text-muted">Taxa</small>
                                <h4 class="h4">{{ advanceSummary.totalFee.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</h4>
                            </div>
                        </div>
                        <div class="col-md-2 col-sm-12">
                            <div class="callout callout-success">
                                <small class="text-muted">Valor final</small>
                                <h4 class="h4">{{ advanceSummary.available.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</h4>
                            </div>                    
                        </div>
                    </div>                
                </b-card>
                
                <b-card>
                    <b-table
                        :items="transactions"
                        :striped="true"
                        :fields="columns"
                        responsive>                        
                    </b-table>
                </b-card>
            </template>
        </template>
        
    </div>
</template>
<script>
import sellerService from "../../../services/Customer/sellerService";
import transactionService from "../../../services/Transactions/transactionService";
import { ModelListSelect } from "vue-search-select";
import { getDateDayBefore } from "../../../shared/utils";
import BalanceSummary from "../../../components/balance/summary2.vue";
import listPage from '../../../mixins/listPage';
import moment from 'moment';
export default {
    mixins: [listPage],
    components: {
        ModelListSelect,
        BalanceSummary
    },
    data() {
        return {
            viewType: 'Seller',    
            request: {               
                startDate: getDateDayBefore(new Date(), 1),
                endDate: new Date(),
                customer: {
                    id: '',
                    name: ''
                },
                amount: 0
            },
            customers: {
                data: [],
                query: '',
            },            
            selectedCustomer: {
                id: '',
                name: ''
            },
            columns: [
                { key: "id", label: "Codigo", sortable: false },
                { key: "installment", label: "Parcela", sortable: false },
                { key: "escrowDate", label: "Data", sortable: false },
                { key: "anticipationDays", label: "Dias de antecip.", sortable: false },                                
                { key: "amount", label: "Valor Bruto", sortable: false },
                { key: "netAmount", label: "Valor liquido", sortable: false }
            ],
            advanceResult: this.getEmptyAdvanceResult(),
            transactions: [],
            summaryModel: this.getEmptyBalanceSummary(),
            advanceSummary: this.getEmptyAdvanceSummary(),
            vueNumericDefaults:{
                decimals: 2,
                separator: '.',
                outputType: 'Number'
            },
        }
    },
    created() {
    },
    methods: {
        validate() {
            if(this.request.customer.id == null || this.request.customer.id == '') {
                this.selectedCustomer.id = '';
                this.selectedCustomer.name = '';
                return;
            }
            this.selectedCustomer.id = this.request.customer.id;
            this.selectedCustomer.name = this.request.customer.name;
            this.fetchSummaryData();
            
        },
        validateAdvanceSimulation(){
            if(this.request.amount <= 0) {
                return;    
            }
            this.fetchData(1);
        },
        antecipate() {
            const self = this;
            this.showLoading();
            transactionService.antecipate(this.advanceResult.id)
                .then((response) => {
                    if(response.status == 202) {
                        self.advanceResult = self.getEmptyAdvanceResult();
                        self.advanceSummary = self.getEmptyAdvanceSummary();
                        self.hideLoading();
                        self.fetchSummaryData();
                    } else {
                        self.hideLoading();
                    }
                }, () => {
                    self.result = self.getEmptyAdvanceResult();
                    self.hideLoading();
                });
        },
        fetchData(page) {
            if(this.request.customer.id == null || this.request.customer.id == '') {
                return;
            }
            const self = this;
            this.showLoading();
            transactionService.advanceSimulation(this.selectedCustomer.id, this.request.amount, this.$auth.partnerKey)
                .then((response) => {
                    if(response.status == 400) {
                        self.advanceResult = self.getEmptyAdvanceResult();
                        self.advanceSummary = self.getEmptyAdvanceSummary();
                    } else {
                        let advance = response.data;
                        self.advanceSummary.totalTransactions = advance.totalTransaction;
                        self.advanceSummary.totalFee = advance.totalFee;
                        self.advanceSummary.available = advance.available;
                        self.advanceResult = advance;
                        let transaction = {};
                        self.transactions = [];
                        for (let index = 0; index < advance.transactions.length; index++) {
                            const trx = advance.transactions[index];
                            transaction.id = trx.id;
                            for (let idx = 0; idx < trx.installments.length; idx++) {
                                const el = trx.installments[idx];
                                transaction.installment = el.installment;
                                transaction.escrowDate = this.formatDateTimeFields(el.escrowDate);
                                transaction.anticipationDays = el.anticipationDays;
                                transaction.netAmount = el.netAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                                transaction.amount = el.amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                                
                            }
                            self.transactions.push(transaction);
                            transaction = {};
                        }
                    }
                    self.hideLoading();
                },
                () => {
                    self.advanceResult = self.getEmptyAdvanceResult();
                    self.advanceSummary = self.getEmptyAdvanceSummary();
                    self.hideLoading();
                })
        },
        formatDateTimeFields(value) {
            return value == null || value == '' ? '' : moment(value).format('DD/MM/YYYY - HH:mm:ss');
        },
        getRequestParams() {
            return {
                customerId: this.selectedCustomer.id,
                startDate: this.request.startDate,
                endDate: this.request.endDate,
                amount: this.request.amount              
            }
        },
        getEmptyBalanceSummary() {
            return { available: 0, inProcess: 0, blocked: 0, total: 0, openDebits: 0 }
        },
        getEmptyAdvanceSummary() {
            return { available: 0, totalTransactions: 0, totalFee: 0 }
        },
        getEmptyAdvanceResult() {
            return this.advanceResult = {
                id: '',
                transactions: []
            };
        },        
        fetchSummaryData() {
            const self = this
            
            transactionService.balance({customerId: this.request.customer.id, customerType: this.viewType})
                .then(
                (response) => {
                    if (response.status == 204) {
                        self.summaryModel.available = 0;
                        self.summaryModel.inProcess = 0;
                        self.summaryModel.total = 0;
                        self.summaryModel.blocked = 0;
                        self.summaryModel.openDebits = 0;   
                    }
                    else {
                        self.summaryModel.available = response.data.available;
                        self.summaryModel.inProcess = response.data.inProcess;
                        self.summaryModel.total = response.data.total;              
                        self.summaryModel.blocked = response.data.onHold;
                        self.summaryModel.openDebits = response.data.openDebits;
                    }                        
                },
                () => {}
            );            
        },
        searchCustomers(newQuery) {
            if (newQuery == null || newQuery.length < 2) return;
            const self = this;
            
            sellerService.all(newQuery).then(
                (response) => {
                    self.customers.data = response.status == 204 ? [] : response.data;
                },
                () => {
                    self.customers.data = [];
                }
            );
            
        }              
    }
}
</script>